import { createAtom } from './createAtom';
export var contentContainerSizeAtom = createAtom(0);
export var homeScrollAmountAtom = createAtom(0);
